import { render, staticRenderFns } from "./ProjectPOABitacoraRecap.vue?vue&type=template&id=5c7f9dea"
import script from "./ProjectPOABitacoraRecap.vue?vue&type=script&lang=js"
export * from "./ProjectPOABitacoraRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports